import Vue from 'vue'
import {IonicVueRouter} from '@ionic/vue'

import Home from '@/components/Home'
import GetCheckin from '@/components/GetCheckin'
import SendCheckin from '@/components/SendCheckin'

Vue.use(IonicVueRouter)

export default new IonicVueRouter({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/GetCheckin',
      name: 'GetCheckin',
      component: GetCheckin
    },
    {
      path: '/SendCheckin',
      name: 'SendCheckin',
      component: SendCheckin
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('../components/Signup.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../components/Login.vue')
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('../components/ForgotPassword.vue')
    },
  ]
})
